import Page from '@averyano/core/src/classes/Page';
import each from 'lodash/each';
import FadeInAnimation from '../../animations/FadeIn';
import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lightbox from '../../components/Lightbox';
export default class BioPage extends Page {
	constructor() {
		super({
			element: '.bio',
			elements: {
				sectionAbout: '.bio__section--about',
				figures: '.bio__figure',
				titles: '.bio__title',
				texts: '.bio__text',
			},
		});

		this.isMobile = window.matchMedia('(max-width: 999px)');
		this.id = 'bio';
		this.isCreated = false;
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();

		if (!this.isCreated) {
			this.components = {
				// about: new AboutSection(),
				// gallery: new GallerySection(),
				// repr: new ReprSection(),
				// contact: new ContactSection(),
			};
			this.isCreated = true;
		}

		// Create Components
		each(this.components, (component) => {
			console.log('create component', component);
			component.create();
		});

		this.lightbox = new Lightbox();
		if (this.elements.figures && this.elements.figures.length)
			this.lightbox.create(this.elements.figures);

		this.createScrollTrigger();
		this.addEventListeners();
		console.log(`🔼 ${this.id} is created`);
	}

	createScrollTrigger = () => {
		// if (window.isMobile) return;
		this.allAnims = [];

		each(this.elements.figures, (figure, i) => {
			const fd = new FadeInAnimation({ element: figure, delay: i * 0.062 });
			this.allAnims.push(fd);
		});
		each(this.elements.titles, (figure, i) => {
			const fd = new FadeInAnimation({ element: figure, delay: i * 0.062 });
			this.allAnims.push(fd);
		});
		each(this.elements.texts, (figure, i) => {
			const fd = new FadeInAnimation({ element: figure, delay: i * 0.062 });
			this.allAnims.push(fd);
		});
		console.log(this.allAnims);
	};

	openLightbox(item, type = 'image') {
		console.log('Open Lightbox', this.isDragging);
		if (this.isDragging) return;
		this.lightbox.setActiveImage(item, type);
		this.lightbox.open();
	}

	show() {
		// this.createScrollTrigger();
	}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	addEventListeners() {
		console.log('BioPage addEventListeners 🔥🔥');
		each(this.components, (component) => {
			component.addEventListeners();
		});
		each(this.elements.figures, (item) => {
			item.addEventListener('click', () => {
				this.openLightbox(item);
			});
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});
		each(this.elements.figures, (item) => {
			item.removeEventListener('click', () => {
				this.openLightbox(item);
			});
		});
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();

		each(this.components, (component) => {
			component.destroy();
		});

		// Removes scroll trigger instances
		const scrolltriggerElements = document.querySelectorAll('.pin-spacer');
		each(scrolltriggerElements, (pinSpacer) => {
			const parent = pinSpacer.parentElement;

			while (pinSpacer.firstChild) {
				parent.appendChild(pinSpacer.firstChild);
			}

			parent.removeChild(pinSpacer);
		});
	}

	update() {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.update();
	}

	updateMousePos(e) {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.updateMousePos(e);
	}

	onResize() {
		console.log('resize design');
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
}
